import { useState } from 'react'
import { Button, Divider, Menu } from 'antd'
import InputConfig from './InputConfig'
import { useCreateMacroData } from './CreateMacroDataProvider'
import { setSteps } from './CreateMacroDataProvider/actions'
import { PlusOutlined } from '@ant-design/icons'
import cuid from 'cuid'
{ SubMenu } = Menu

StepsConfig = ->

  [state, dispatch] = useCreateMacroData()
  [selected, setSelected] = useState(state.steps[0]?[0])
  [openKey, setOpenKey] = useState('step-1')
  { steps, fieldData } = state

  moveUp = ->
    for step, stepIndex in steps
      for field, fieldIndex in step
        if selected is field
          currentStep = stepIndex
          currentField = fieldIndex
    return if currentField is 0
    newSteps = Array.from(steps)
    newSteps[currentStep].splice(currentField, 1)
    newSteps[currentStep].splice(currentField - 1, 0, selected)
    dispatch(setSteps(newSteps))

  moveDown = ->
    for step, stepIndex in steps
      for field, fieldIndex in step
        if selected is field
          currentStep = stepIndex
          currentField = fieldIndex
    return if currentField is steps[currentStep].length - 1
    newSteps = Array.from(steps)
    newSteps[currentStep].splice(currentField, 1)
    newSteps[currentStep].splice(currentField + 1, 0, selected)
    dispatch(setSteps(newSteps))

  <div style={{ display: 'flex', flexDirection: 'row', height: 'calc(100% - 73px)' }}>
    <div className='steps-config'>
      <Menu
        style={{ width: 256, overflowY: 'auto', overflowX: 'hidden', height: '80%', borderRadius: '9px' }}
        openKeys={[openKey]}
        selectedKeys={[selected]}
        mode="inline"
        onSelect={({ key }) -> setSelected(key) }
      >
        {steps.map((step, i) ->
          <SubMenu
            key="step-#{ i + 1 }"
            title="Step #{ i + 1 }"
            onTitleClick={({ key }) -> setOpenKey(key)}
          >
            {step.map((key, j) ->
              <Menu.Item key={key}>
                { fieldData[key]?.key or "Step #{ i + 1 } field #{ j + 1 }" }
              </Menu.Item>
            )}
            <Menu.Item key="new-field-at-step-#{ i }" disabled style={{ cursor: 'default', width: 256 }}>
              <Button
                onClick={ ->
                  newField = cuid()
                  newSteps = Array.from(steps)
                  newSteps[i] = [newSteps[i]..., newField]
                  dispatch(setSteps(newSteps))
                  setSelected(newField)
                }
                icon={<PlusOutlined />}
                type="link"
                style={{ float: 'right', position: 'relative', top: 5 }}
              >Add new field</Button>
            </Menu.Item>
          </SubMenu>
        )}
      </Menu>
      <div className='step-controls' style={{ marginTop: '5%', display: 'grid', justifyContent: 'left' }}>
        <div className='step-controls-arrows' style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button
            onClick={(e) ->
              moveUp()
            }
            type="primary"
          >Up^</Button>
          <Button
            onClick={(e) ->
              moveDown()
            }
            type="primary"
          >Down v</Button>
        </div>
      
      <Button
        onClick={(e) ->
          dispatch(setSteps([steps..., []]))
          setOpenKey('step-' + (steps.length + 1))
        }
        icon={<PlusOutlined />}
        type="primary"
        style={{ marginTop: '5%' }}
      >Add new step</Button>
      </div>
    </div>
      
    
    <InputConfig fieldKey={selected} setSelected={setSelected} />
  </div>

export default StepsConfig
